namespace TabAurous {
    export interface ShortListRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Reports.ShortListRow[];
        CategoryWiseItems?: TabAurous.Reports.ShortListCategoryWiseRow[];
    }
}
